import { useState } from 'react';

import { Close } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';

import { Analytics } from '../analytics/Analytics';
import { AnalyticsEvent } from '../analytics/AnalyticsEvent';

export function UseChromeInsteadOfSafari(): React.JSX.Element | null {
  const [visible, setVisible] = useState(true);

  const isSafari = typeof (window as any).safari !== 'undefined';
  if (!isSafari) {
    return null;
  }

  const storageKey = 'LastDateWhenSafariUserClosedSuggestionToUseChromeInstead';
  const lastDateStr = localStorage.getItem(storageKey);
  let isExplicitlyClosed = false;
  if (lastDateStr) {
    const lastDateMs = parseInt(lastDateStr);
    const nowMs = Date.now();
    const timeSinceCloseMs = nowMs - lastDateMs;
    const maxDurationMsToShowPopupAgain = 1000 * 60 * 60 * 4;
    isExplicitlyClosed = timeSinceCloseMs < maxDurationMsToShowPopupAgain;
  }
  if (isExplicitlyClosed) {
    return null;
  }

  if (!visible) {
    setVisible(true);
  }

  return (
    <Stack className="use-google-chrome" direction="row" alignItems="center">
      <span>⚠️ For the better performance please use Google Chrome</span>
      <IconButton
        onClick={() => {
          localStorage.setItem(storageKey, Date.now().toString());
          setVisible(false);
          Analytics.log(AnalyticsEvent.CloseSuggestionToUseChrome);
        }}
      >
        <Close />
      </IconButton>
    </Stack>
  );
}
